import type { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const contentItemStyles = makeStyles((theme: Theme) => ({
  item: {
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
    '&>div:only-child': {
      flex: 1
    }
  },
  itemVertical: {
    flexDirection: 'column',
    alignItems: 'start'
  },
  title: {
    minHeight: '81px',
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(3)
  }
}));

export default contentItemStyles;
